"use strict";

exports.__esModule = true;
exports.default = void 0;

/**
 * Licensed Materials - Property of IBM
 * IBM Business Analytics (C) Copyright IBM Corp. 2020
 * US Government Users Restricted Rights - Use, duplication or disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
 */

/**
 * @class UIConditionalFormattingAPI
 * @description This API is use mainly to support the UI of the Conditional Formatting feature.
 * Other clients such as system test would not have access to this API
 * @hideconstructor
 */
var UIConditionalFormattingAPI = /*#__PURE__*/function () {
  function UIConditionalFormattingAPI() {}

  var _proto = UIConditionalFormattingAPI.prototype;

  /**
   * @function UIConditionalFormattingAPI#getRule
   * @description Retrieve and return the rule search by dataItemId and ruleIndex
   * @param {String} dataItemId - DataItem id used to get the rule
   * @param {Number} ruleIndex - An index number for the rule
   * @return {Rule} The rule retrieved from dataItemId and ruleIndex
   */
  _proto.getRule = function getRule() {};

  _proto.getProvider = function getProvider() {};

  _proto.slotMappingIsReady = function slotMappingIsReady() {};

  return UIConditionalFormattingAPI;
}();

exports.default = UIConditionalFormattingAPI;
